exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container{\r\n  padding: 1%;\r\n}\r\n.logo{\r\n  text-align: center;\r\n  padding-bottom: 3%;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/about/about.component.css
// module id = ../../../../../src/app/about/about.component.css
// module chunks = main